import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicAlerts from './BasicAlerts';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicAlerts, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/alert/demos/basic/BasicAlerts.tsx",
    "fileName": "BasicAlerts.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Alert from '@mui/material/Alert';\nimport Stack from '@mui/material/Stack';\n\nexport default function BasicAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Alert severity=\"success\">This is a success Alert.</Alert>\n      <Alert severity=\"info\">This is an info Alert.</Alert>\n      <Alert severity=\"warning\">This is a warning Alert.</Alert>\n      <Alert severity=\"error\">This is an error Alert.</Alert>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 13,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Alert from '@mui/material/Alert';\nimport Stack from '@mui/material/Stack';\n\nexport default function BasicAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Alert severity=\"success\">This is a success Alert.</Alert>\n      <Alert severity=\"info\">This is an info Alert.</Alert>\n      <Alert severity=\"warning\">This is a warning Alert.</Alert>\n      <Alert severity=\"error\">This is an error Alert.</Alert>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">This is a success Alert.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "info",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">This is an info Alert.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "warning",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">This is a warning Alert.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "error",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">This is an error Alert.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 13,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/Alert",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
